import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import projectService from "../../services/projectService";
import Cookies from "js-cookie";

export const initialState = {
    loading_project: false,
    data_project: [],
    showMessage:false,
    message:'',
}


export const getDataProject = createAsyncThunk('project/data',async (data, { rejectWithValue }) => {
    try {
        const response = await projectService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_project = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataProject.fulfilled, (state, action) => {
                state.loading_project = false
                state.data_project = action.payload??[]
            })
            .addCase(getDataProject.pending, (state) => {
                state.loading_project = true
            })
            .addCase(getDataProject.rejected, (state, action) => {
                state.loading_project = false
                state.data_project = action.payload
            })
    },
})

export const {
    showLoading,
} = projectSlice.actions

export default projectSlice.reducer
